module.exports = __webpack_public_path__ + "img/ruleTemplate.d309be47.svg";